<template>
  <div
    class="review-input-content"
    :class="{ 'review-input-padding': data.replace }"
  >
    <van-field
      v-model="data.value"
      rows="2"
      :autosize="autosizeObj"
      label=""
      @blur="bindBlur"
      type="textarea"
      :placeholder="data.placeholder || '请输入内容'"
      :maxlength="data.maxlength"
      :show-word-limit="!data.replace"
    />
    <!-- <textarea
      class="textarea"
      rows="3"
      autosize
      @blur="bindBlur"
      v-model="data.value"
      :placeholder="data.placeholder || '请输入内容'"
      :maxlength="data.maxlength"
    ></textarea> -->
    <div class="tip">{{ tips }}</div>
    <div class="replace" v-if="data.replace" @click="bindReplace">
      <span class="iconfont icon-shuaxin"></span><span>换一句</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      tips: '',
      autosizeObj: { maxHeight: 120, minHeight: 48 }
    }
  },
  methods: {
    bindReplace() {
      this.$emit('replace', this.data.val)
    },
    checkWords() {
      if (this.data.minlength === undefined) {
        return
      }
      if (this.data.value.length < this.data.minlength) {
        this.tips = '字数不能少于' + this.data.minlength + '字'
      } else {
        this.tips = ''
      }
    },
    bindBlur() {
      this.checkWords()
    }
  }
}
</script>
<style lang="scss">
.review-input-content {
  .van-cell {
    background: transparent;
  }
  .van-cell::after {
    border-bottom: none;
  }
}
</style>
<style lang="scss" scoped>
.review-input-padding {
  padding-bottom: 17px;
}
.review-input-content {
  position: relative;
  .textarea {
    padding: 10px 13px;
    box-sizing: border-box;
    width: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    resize: none;
    //height: 96px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 24px;
    max-height: 140px;
  }
  .replace {
    position: absolute;
    bottom: 10px;
    right: 16px;
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 17px;
    .iconfont {
      color: rgba(0, 0, 0, 0.3);
      margin-right: 4px;
    }
  }
  .tip {
    position: absolute;
    bottom: 10px;
    left: 16px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #ee0a24;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
}
</style>
